/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

class Storage {
  name;

  constructor(name: string) {
    this.name = name;
  }

  getStorage() {
    const data = window.localStorage.getItem(this.name);

    return data ? JSON.parse(data) : {};
  }

  save(storage: unknown) {
    window.localStorage.setItem(this.name, JSON.stringify(storage));
  }

  get(k: string) {
    const data = this.getStorage();

    return data[k];
  }

  set(k: string, v: unknown) {
    const data = this.getStorage();
    data[k] = v;

    this.save(data);
  }

  clear(key: string) {
    const data = this.getStorage();

    delete data[key];
    this.save(data);
  }
}

const storage = new Storage('_roboMgmtStorage');

export default storage;
